<template>
    <div class="o-deficiencies">
        <div class="l-row m-card">
            <div class="l-row__column m-card__column">
                <!-- <div class="l-row m-card__container">
                    <m-control
                        :background-gray="true"
                        type="searchText"
                        label="Agrofag"
                        placeholder="Znajdź..."
                        name="agrofags"
                        model-name="agrofags"
                        @input="build('name', $event)"
                        :value="query['name']"
                    />
                </div> -->
            </div>
            <m-tabs
                :items="agrofagTypes"
                @input="buildFilter($event)"
                :selected="query.agrofag_type_id.toString()"
            />
        </div>
        <o-list
            vuex-action-fetch="fetchAgrofags"
            vuex-action-fetch-next-page="fetchAgrofagsNextPage"
            vuex-getter-model="agrofags"
            vuex-getter-status="agrofagsStatus"
            router-single-name="agrofag"
        >
            <template slot="list" slot-scope="props">
                <div class="m-list__itemPhoto">
                    <a-image
                        v-if="props.list.item.photos && props.list.item.photos.length > 0 && !!props.list.item.photos.find(item => item.is_main === true)"
                        :src="props.list.item.photos.find(item => item.is_main === true).full_uri"
                        :alt="props.list.item.name"
                    />
                    <a-icon
                        v-else
                        icon="Agrofags"
                    />
                </div>
                <p class="m-list__itemTitle m-list__itemTitle--margins m-list__itemTitle--capitalize">
                    {{ props.list.item.name }}
                </p>
            </template>
        </o-list>
    </div>
</template>

<script>
export default {
    metaInfo: {
        title: 'Agrofagi'
    },
    computed: {
        query() {
            return this.$store.getters.agrofagsQuery
        },
        agrofagTypes() {
            return this.$store.getters.agrofagTypes
        }
    },
    mounted() {
        this.$store.dispatch('fetchAgrofagTypes')
    },
    methods: {
        build(name, value) {
            this.$store.dispatch('setAgrofagsSearchQuery', {
                name,
                value
            }).then(() => {
                this.$store.dispatch('fetchAgrofags').catch(() => {})
            })
        },
        buildFilter(type) {
            this.$store.dispatch('setAgrofagsSearchQuery', {
                agrofag_type_id: type.id

            }).then(() => {
                this.$store.dispatch('fetchAgrofags').catch(() => {})
            })
        }
    }
}
</script>
